import { Flex, Text } from 'pcln-design-system'
import React from 'react'
import { VIP_COLORS } from '../colorVariations'
import { TIERS } from '../constants'
import { BenefitsTableTierBadge, MobileTabContent, MobileTabWrapper, TierLabel } from './styledComponents'

const MobileTab = ({ levelName, levelLabel, activeTab, onClick }) => (
  <MobileTabContent
    onClick={onClick}
    color={activeTab === levelName ? 'background.light' : 'background.lightest'}
  >
    <BenefitsTableTierBadge size='small' level={levelName} layout='stacked'></BenefitsTableTierBadge>
    {activeTab === levelName ? <TierLabel textAlign='center'>{levelLabel}</TierLabel> : null}
  </MobileTabContent>
)

const MobileTabs = ({
  headerText = 'VIP Benefits by level',
  headerRow,
  activeTab = 'member',
  onSelect,
  className,
  ...props
}) => (
  <>
    <Flex justifyContent='center'>
      <Text fontSize={2} my={3} lineHeight='19px' color={VIP_COLORS.secondary}>
        {headerText}
      </Text>
    </Flex>
    <MobileTabWrapper className={className} {...props}>
      {TIERS.map((level) => (
        <MobileTab
          key={level}
          levelName={level}
          levelLabel={headerRow[level]}
          activeTab={activeTab}
          onClick={() => {
            onSelect(level)
          }}
        />
      ))}
    </MobileTabWrapper>
  </>
)

export { MobileTabs }
